var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  404 Not Found\n  "),_c('hr'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Top")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }